import React from 'react';
import { useTranslation } from 'react-i18next';
import { css } from 'linaria';
import { ButtonWithGAClickButton, Typography } from 'common/components';

const textStyle = css`
  display: block;
  max-width: 776px;
  margin-bottom: 24px;

  @media (--only-desktop) {
    max-width: 740px;
  }

  @media (--to-desktop) {
    max-width: 100%;
  }
`;

export const SizingInstruction = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography size="body_long" variant="m" className={textStyle}>
        {t('sizing-section.instruction.description')}
      </Typography>
      <ButtonWithGAClickButton
        aria-label={t('sizing-section.instruction.button-name') || ''}
        elementBlock="landingVannuyuKomnatu"
        elementName={t('sizing-section.instruction.button-name')}
        elementText={t('sizing-section.title')}
        href="/advice/santehnika/kak-izmerit-vannuyu-komnatu/"
        title={t('sizing-section.instruction.title') || ''}>
        {t('sizing-section.instruction.button-name')}
      </ButtonWithGAClickButton>
    </>
  );
};
